
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from '../locales/en/translation.json';
import esTranslation from '../locales/es/translation.json';
import frTranslation from '../locales/fr/translation.json';
import soTranslation from '../locales/so/translation.json';
import hmTranslation from '../locales/hm/translation.json';

// Initialize i18next with language detector
i18n
  .use(LanguageDetector) // Add the language detector
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      es: { translation: esTranslation },
      fr: { translation: frTranslation },
      so: { translation: soTranslation },
      hm: { translation: hmTranslation },
    },
    fallbackLng: 'en', // Fallback to English if preferred language isn't supported
    supportedLngs: ['en', 'es', 'fr', 'so', 'hm'],
    detection: {
      order: ['navigator', 'localStorage', 'htmlTag'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
